
import React from 'react';

interface ProgressProps {
  value: number; // 0 to 100
  className?: string;
}

const Progress: React.FC<ProgressProps> = ({ value, className }) => {
  const progress = Math.min(100, Math.max(0, value));
  return (
    <div className={`w-full bg-muted rounded-full h-2.5 ${className}`}>
      <div 
        className="bg-primary h-2.5 rounded-full transition-all duration-300" 
        style={{ width: `${progress}%` }}
        role="progressbar"
        aria-valuenow={progress}
        aria-valuemin={0}
        aria-valuemax={100}
      ></div>
    </div>
  );
};

export default Progress;
